import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper';

import PersonProfileTable from './PersonProfileTable';

export default class JockeyProfileEntriesPage extends Component {
  static propTypes = {
    profile: PropTypes.object
  };

  render() {
    const {
      profile = {},
      profile: {
        person_details: {
          name
        } = {}
      } = {}
    } = this.props;

    return (
      <div className="hr-jockey-profile-results">
        <MetaDataWrapper title={`${name} - Jockey Future Entries`} />
        <PersonProfileTable profile={profile} rideLabel="Ride" earlyEntries />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/Profiles/JockeyProfileEntriesPage.js